import { RouteObject } from "react-router-dom";
import routePaths from "./../../constants/routes";
import ProtectedRoutes from "utils/ProtectedRoutes";
import React from "react";
import Loader from "components/UI/Loader";

const Meet = React.lazy(() => import("pages/meet"));

export const meetRoutes: RouteObject[] = [
	{
		path: routePaths.MEET.__PATH,
		element: (
			<ProtectedRoutes>
				<React.Suspense fallback={<Loader />}>
					<Meet />
				</React.Suspense>
			</ProtectedRoutes>
		),
	},
];
